import { STATICS } from 'statics'
import './style.scss'

export function CartIcon({ numberOfItems }) {
  function renderNumberOfItems() {
    if (!numberOfItems) return null

    return <span className='cart-number'> {numberOfItems} </span>
  }

  return (
    <div className='container-cart-icon'>
      <STATICS.CART className='cart-icon' />
      {renderNumberOfItems()}
    </div>
  )
}
